<template>
  <div style="color: whitesmoke; border-color: whitesmoke">
    <b-card-group deck>
      <b-card
          header="featured"
          header-tag="header"
          footer="Card Footer"
          footer-tag="footer"
          title="Title"
      >
        <b-card-text>Header and footers using props.</b-card-text>

      </b-card>

      <b-card title="Title" header-tag="header" footer-tag="footer">
        <template #header>
          <h6 class="mb-0">Header Slot</h6>
        </template>
        <b-card-text>Header and footers using slots.</b-card-text>
        <template #footer>
          <em>Footer Slot</em>
        </template>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: "MyApp_DetailView_Screenshots",
  components: {},
  props: {
    tool: {
      type: Object,
      default: () => {return {}}
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped></style>
